import * as types from '../constants';

const byId = (state = {}, action) => {
  switch (action.type) {
    case types.IMPORT_APPOINTMENTS:
    case types.ADD_APPOINTMENT:
    case types.UPDATE_APPOINTMENT:
    case types.CANCEL_APPOINTMENT:
    case types.GET_APPOINTMENT:
      return {
        ...state,
        ...action.response.entities.appointments,
      };
    default:
      return state;
  }
};

export default byId;
